/**
 * @generated SignedSource<<969e874277a66b3f3af366fa762020d3>>
 * @relayHash 08ce84df83c28ee942e51d34169f573a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d04f5e5da3c02e9a79c38c18f4b771230dd112adb2c02e86bb4923ba883d7c7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cardCoverSettingsQuery$variables = {
  boardId: string;
};
export type cardCoverSettingsQuery$data = {
  readonly boardScope: {
    readonly board: {
      readonly " $fragmentSpreads": FragmentRefs<"cardPreview_ProjectSettingsBoardSettingsCard" | "toggle_ProjectSettingsBoardSettingsCard_CardCoverToggle">;
    };
  };
};
export type cardCoverSettingsQuery = {
  response: cardCoverSettingsQuery$data;
  variables: cardCoverSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "cardCoverSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "SoftwareBoard",
                "kind": "LinkedField",
                "name": "board",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "toggle_ProjectSettingsBoardSettingsCard_CardCoverToggle"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "cardPreview_ProjectSettingsBoardSettingsCard"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.board"
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cardCoverSettingsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          {
            "concreteType": "SoftwareBoard",
            "kind": "LinkedField",
            "name": "board",
            "plural": false,
            "selections": [
              {
                "concreteType": "CardMediaConfig",
                "kind": "LinkedField",
                "name": "cardMedia",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              },
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "2d04f5e5da3c02e9a79c38c18f4b771230dd112adb2c02e86bb4923ba883d7c7",
    "metadata": {},
    "name": "cardCoverSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0a38c0557dcf4e2928b9bc164b447b32";

export default node;
